<template>
    <div class="or-content fill-page">
            <slot>
                
            </slot>
    </div>
</template>

<script>
export default {

}
</script>

<style>
    .or-content {
        position: relative;
        width: 100vw;
        min-width: 1200px;
        background-image: url(../../assets/content-bg.svg);
        background-position: center;
        background-size: cover;
    }
</style>